import { render, staticRenderFns } from "./CollectionAll.vue?vue&type=template&id=efbf90f0"
import script from "./CollectionAll.vue?vue&type=script&lang=js"
export * from "./CollectionAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports